"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    const { type, html, link, zipFile, zipPath } = element.value;
    switch (type) {
        case 'link':
            if (link) {
                return `[Embedded content: ${link}]\n\n`;
            }
            break;
        case 'html':
            if (html) {
                return '[Embedded HTML content]\n\n';
            }
            break;
        case 'zip':
            if (zipFile) {
                const url = (0, md_utils_1.getFileUrl)(zipFile, context);
                const displayName = url || zipFile.key || zipFile.id || 'archive';
                const path = zipPath ? ` (${zipPath})` : '';
                return `[Embedded content: ${displayName}${path}]\n\n`;
            }
            break;
    }
    return '';
};
exports.toMarkdown = toMarkdown;
